import { getSize } from '../theme/iconSizes'
import IconProps from './Icon'

const Circle = ({ iconSize, fillColor }: IconProps) => {
  const size = getSize(iconSize)

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <circle key="1" cx={12} cy={12} r={12} fill={fillColor} />
      </g>
    </svg>
  )
}

export default Circle
